//import firebase from 'firebase/app';
//import 'firebase/functions';

import parentProductService from '@/app-template/lib/services/ProductService';

export default {
  ...parentProductService,
}